<app-spinner [show]="showSpinner"></app-spinner>
<!-- Start Register Area -->
<section class="register-area">
    <div class="row m-0">
        <div class="col-lg-6 col-md-12 p-0">
            <div class="register-image">
                <img src="assets/img/register-bg.jpg" alt="image">
            </div>
        </div>

        <div class="col-lg-6 col-md-12 p-0">
            <div class="register-content">
                <div class="d-table">
                    <div class="d-table-cell">
                        <div class="register-form">
                            <div class="logo">
                                <a routerLink="/"><img src="assets/img/black-logo.png" alt="image"></a>
                            </div>

                            <h3>{{newAccount}}</h3>
                            <p>{{signedUp}} <a [routerLink]="['/login']">{{login}}</a></p>

                            <form [formGroup]="registerForm" (ngSubmit)="onSubmit()">
                                <div class="form-group">
                                    <input type="text" placeholder="{{nameText}}" class="form-control" formControlName="name">
                                    <div *ngIf="name.invalid && (name.dirty || name.touched)"
                                        class="alert alert-danger">
                                        <div *ngIf="name.errors.required">
                                            Name is required.
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <select #selectSex class="form-control" formControlName="sex">
                                        <option value="">{{sexText}}</option>
                                        <option value="1">{{male}}</option>
                                        <option value="2">{{female}}</option>
                                    </select>
                                </div>

                                <div class="form-group">
                                    <input placeholder="{{dobText}}" class="dob" type="date" id="date" formControlName="dob" value="">
                                </div>

                                <div class="form-group">
                                    <input type="text" placeholder="{{phoneText}}" class="form-control"
                                        formControlName="phoneNumber" (input)="numbersOnlyValidator($event)">
                                    <div *ngIf="phoneNumber.invalid && (phoneNumber.dirty || phoneNumber.touched)"
                                        class="alert alert-danger">
                                        <div *ngIf="phoneNumber.errors.required">Phone is required.</div>
                                        <div *ngIf="phoneNumber.errors.pattern">Invalid Phone.</div>
                                    </div>
                                </div>

                                <div class="form-group inputcontainer">
                                    <input type="email" placeholder="{{emailForLogin}}"
                                        class="form-control is-loading is-loading-sm" formControlName="email"
                                        (keyup)="onEmailTextFieldKeyUp($event)">
                                    <div *ngIf="isCheckingUser" class="icon-container">
                                        <i class="loader"></i>
                                    </div>
                                    <div *ngIf="email.invalid && (email.dirty || email.touched); else elseBlock"
                                        class="alert alert-danger">
                                        <div *ngIf="email.errors.required">Email is required.</div>
                                        <div *ngIf="email.invalid && !email.errors.required">Invalid email.</div>
                                    </div>
                                    <ng-template #elseBlock>
                                        <div class="alert alert-danger" *ngIf="isUserExist">Duplicated Email Address</div>
                                    </ng-template>
                                </div>

                                <div
                                class="otp-modal-backdrop"
                                *ngIf="otpSent && !otpVerified"
                                >
                                <div
                                    class="otp-modal-panel"
                                    role="dialog"
                                    aria-modal="true"
                                    aria-labelledby="otp-title"
                                >
                                    <!-- Close -->
                                    <button
                                    type="button"
                                    class="otp-close-btn"
                                    (click)="resetOtpState()"
                                    aria-label="Close OTP modal"
                                    >
                                    <span aria-hidden="true">&times;</span>
                                    </button>

                                    <!-- Heading -->
                                    <div class="otp-content">
                                    <h4 id="otp-title">Verify your email</h4>

                                    <p class="otp-description">
                                        We sent a 4-digit verification code to
                                    </p>

                                    <div class="otp-email">
                                        {{ otpEmail }}
                                    </div>

                                    <p class="otp-hint">
                                        Enter the code below to continue your registration.
                                    </p>
                                    </div>

                                    <!-- OTP Input -->
                                    <div class="otp-field">
                                    <label for="otpCode">Verification code</label>

                                    <input
                                        id="otpCode"
                                        type="text"
                                        inputmode="numeric"
                                        autocomplete="one-time-code"
                                        pattern="[0-9]*"
                                        maxlength="4"
                                        class="otp-input"
                                        placeholder="0000"
                                        [value]="otpCode"
                                        (input)="otpCode = $any($event.target).value"
                                    />
                                    </div>

                                    <!-- Verify -->
                                    <button
                                    type="button"
                                    class="otp-verify-btn"
                                    (click)="verifyOtpCode()"
                                    [disabled]="isVerifyingOtp || otpCode.length !== 4"
                                    >
                                    <span
                                        class="loader"
                                        *ngIf="isVerifyingOtp"
                                    ></span>

                                    <span>
                                        {{ isVerifyingOtp ? 'Verifying code...' : 'Verify email' }}
                                    </span>
                                    </button>

                                    <!-- Success -->
                                    <div
                                    class="otp-success"
                                    *ngIf="otpVerified"
                                    >
                                    <i class="fa fa-check-circle"></i>
                                    Email verified successfully.
                                    </div>
                                </div>
                                </div>

                                <div class="form-group">
                                    <input type="{{isShow ? 'text' : 'password'}}" placeholder="{{passwordText}}" class="form-control"
                                        formControlName="password">
                                    <i
                                        class="bx"
                                        [ngClass]="isShow ? 'bx-hide' : 'bx-show'"
                                        (click)="isShow = !isShow"
                                        style="cursor: pointer;"
                                    ></i>
                                    <div *ngIf="password.invalid && (password.dirty || password.touched)"
                                        class="alert alert-danger">
                                        <div *ngIf="password.errors.required">Password is required.</div>
                                        <div *ngIf="password.errors.minlength">Password must be at least 6 characters long.</div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <input type="{{isShowRepeat ? 'text' : 'password'}}" placeholder="{{repeatPasswordText}}" class="form-control"
                                        formControlName="repeatPassword">
                                    <i
                                        class="bx"
                                        [ngClass]="isShowRepeat ? 'bx-hide' : 'bx-show'"
                                        (click)="isShowRepeat = !isShowRepeat"
                                        style="cursor: pointer;"
                                    ></i>
                                    <div *ngIf="repeatPassword.invalid && (repeatPassword.dirty || repeatPassword.touched)"
                                        class="alert alert-danger">
                                        <div *ngIf="repeatPassword.errors.required">Password is required.</div>
                                        <div *ngIf="repeatPassword.errors.minlength">Password must be at least 6 characters long.</div>
                                        <div *ngIf="repeatPassword.errors.mustMatch">Passwords must match</div>
                                    </div>
                                </div>

                                <button type="submit"
                                    [ngClass]="{'disabled-button': registerForm.invalid || isUserExist || isSendingOtp}"
                                    [disabled]="isSendingOtp">
                                    <span *ngIf="!isSendingOtp">{{signUp}}</span>
                                    <span *ngIf="isSendingOtp">Sending code...</span>
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Register Area -->